<template>
  <div id="theme-customizer">
    <vs-popup
      fullscreen
      class="profile-card"
      title="Presentation Show"
      :active.sync="flag"
    >
      <iframe class="editor-iframe" title="Coaching and Mentoring as levers of conscious leadership" :src="psrc" tabindex="0" data-auto-height="true" data-aspect-ratio="1.7790927021696252" scrolling="no" width="100%"  frameborder="0"></iframe>
    </vs-popup>
    <vs-popup
      fullscreen
      class="profile-card"
      title="Video "
      :active.sync="flag1"
    >

      <iframe  class="editor-iframe" :src="vsrc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </vs-popup>
    <!-- Open Customizer Button -->
<!--    <vs-button-->
<!--      @click.stop="active=!active"-->
<!--      color="primary"-->
<!--      type="filled"-->

<!--    >Training Center</vs-button>-->

    <!-- Customizer Content -->
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding">
      <div class="h-full">

        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>Training Center</h4>

          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>

        <vs-divider class="mb-0" />

        <component :is="scrollbarTag" class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">
          <p class="mb-4 ml-4"><b>Presentations</b></p>
          <carousel :per-page="1" :paginationEnabled="true">
            <slide v-for="item in presentationsData" :key="presentationsData">
              <img @click="presentationShow(item)" :src="item.image" :title="item.title" style="height: 130px; width: 220px;" >
            </slide>
          </carousel>
          <vs-divider />
          <p class="mb-4 ml-4"><b>Videos</b></p>

          <carousel :per-page="2" :paginationEnabled="true">
            <slide v-for="item in videosData" :key="videosData">
              <img @click="videoPlay(item)" :src="item.image" style="height: 130px; width: 200px;">
            </slide>
          </carousel>
          <vs-divider />
          <p class="mb-4 ml-4"><b>Books</b></p>

          <carousel :per-page="2" :paginationEnabled="true">
            <slide v-for="item in booksData" :key="booksData">
              <a :href="item.url" target="_blank"><img :src="item.image" style="height: 300px; width: 220px;" ></a>
            </slide>
          </carousel>
          <!--          <div class="px-6">-->

          <!--            &lt;!&ndash; Layout Type &ndash;&gt;-->
          <!--            <div class="mt-4">-->
          <!--              <h5 class="mb-2">Layout Type</h5>-->
          <!--              <div>-->
          <!--                <vs-radio v-model="layoutType" vs-value="vertical" class="mr-4" vs-name="layout-type-vertical">Vertical</vs-radio>-->
          <!--                <vs-radio v-model="layoutType" vs-value="horizontal" class="mr-4" vs-name="layout-type-horizontal">Horizontal</vs-radio>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; THEME COLORS &ndash;&gt;-->
          <!--            <div>-->
          <!--              <h5 class="mb-4">Theme Color</h5>-->
          <!--              <ul class="clearfix">-->

          <!--                &lt;!&ndash; Color Square &ndash;&gt;-->
          <!--                <li-->
          <!--                  v-for="color in themeColors"-->
          <!--                  :key="color"-->
          <!--                  :style="{backgroundColor: color}"-->
          <!--                  :class="{'shadow-outline': color == primaryColor}"-->
          <!--                  class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"-->
          <!--                  @click="updatePrimaryColor(color)" />-->

          <!--                &lt;!&ndash; Custom Color Square &ndash;&gt;-->
          <!--                <li-->
          <!--                  :style="{backgroundColor: customPrimaryColor}"-->
          <!--                  :class="{'shadow-outline': customPrimaryColor == primaryColor}"-->
          <!--                  class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"-->
          <!--                  @click="updatePrimaryColor(customPrimaryColor)" />-->
          <!--                <li class="float-left"><input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="customPrimaryColor" type="color" /></li>-->
          <!--              </ul>-->
          <!--            </div>-->
          <!--            &lt;!&ndash; /THEME COLORS &ndash;&gt;-->


          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; THEME &ndash;&gt;-->
          <!--            <div class="mt-4">-->
          <!--              <h5 class="mb-2">Theme Mode</h5>-->
          <!--              <div>-->
          <!--                <vs-radio v-model="themeMode" vs-value="light" class="mr-4" vs-name="theme-mode-light">Light</vs-radio>-->
          <!--                <vs-radio v-model="themeMode" vs-value="dark" class="mr-4" vs-name="theme-mode-dark">Dark</vs-radio>-->
          <!--                <vs-radio-->
          <!--                  v-if="layoutType === 'vertical'"-->
          <!--                  v-model="themeMode"-->
          <!--                  vs-value="semi-dark"-->
          <!--                  vs-name="theme-mode-semi-dark">Semi Dark</vs-radio>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            <template v-if="layoutType === 'vertical'">-->

          <!--              &lt;!&ndash; COLLAPSE SIDEBAR &ndash;&gt;-->
          <!--              <div class="mt-4 flex justify-between">-->
          <!--                <h5>Collapse Sidebar</h5>-->
          <!--                <vs-switch v-model="reduced_sidebar" />-->
          <!--              </div>-->

          <!--              <vs-divider />-->

          <!--            </template>-->

          <!--            &lt;!&ndash; NAVBAR COLOR &ndash;&gt;-->

          <!--            <template v-if="layoutType === 'vertical'">-->

          <!--              <div class="mt-4">-->
          <!--                <h5>Navbar Color</h5>-->
          <!--                <ul class="clearfix">-->

          <!--                  &lt;!&ndash; WHITE COLOR &ndash;&gt;-->
          <!--                  <li-->
          <!--                    :style="{background: navbarColorInitial}"-->
          <!--                    class="w-10 m-2 h-10 rounded-lg float-left cursor-pointer border border-solid d-theme-border-grey-light"-->
          <!--                    :class="navbarColorOptionClasses(navbarColorInitial)"-->
          <!--                    @click="navbarColorLocal = navbarColorInitial " />-->

          <!--                  &lt;!&ndash; THEME COLORS &ndash;&gt;-->
          <!--                  <li-->
          <!--                    v-for="color in themeColors"-->
          <!--                    :key="color"-->
          <!--                    :style="{backgroundColor: color}"-->
          <!--                    :class="navbarColorOptionClasses(color)"-->
          <!--                    class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"-->
          <!--                    @click="navbarColorLocal = color" />-->

          <!--                  &lt;!&ndash; CUSTOM COLOR &ndash;&gt;-->
          <!--                  <li-->
          <!--                    :style="{backgroundColor: customNavbarColor}"-->
          <!--                    :class="navbarColorOptionClasses(navbarColorOptionClasses)"-->
          <!--                    class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"-->
          <!--                    @click="navbarColorLocal = customNavbarColor" />-->

          <!--                  <li class="float-left">-->
          <!--                    <input class="w-10 cursor-pointer h-10 rounded-lg m-2" v-model="customNavbarColor" type="color" />-->
          <!--                  </li>-->
          <!--                </ul>-->
          <!--              </div>-->
          <!--              &lt;!&ndash; /NAVBAR COLOR &ndash;&gt;-->

          <!--              <vs-divider />-->

          <!--            </template>-->

          <!--            &lt;!&ndash; NAVBAR TYPE &ndash;&gt;-->
          <!--            <div class="mt-4">-->
          <!--              <h5 class="mb-2">{{ (layoutType === 'vertical' || windowWidth &lt; 1200) ? "Navbar" : "Nav Menu" }} Type</h5>-->
          <!--              <div>-->
          <!--                <vs-radio-->
          <!--                  v-if="layoutType === 'vertical' || windowWidth < 1200"-->
          <!--                  v-model="navbarTypeLocal"-->
          <!--                  vs-value="hidden"-->
          <!--                  class="mr-4"-->
          <!--                  vs-name="navbar-type-hidden">Hidden</vs-radio>-->

          <!--                <vs-radio v-model="navbarTypeLocal" vs-value="static" class="mr-4" vs-name="navbar-type-static">Static</vs-radio>-->
          <!--                <vs-radio v-model="navbarTypeLocal" vs-value="sticky" vs-name="navbar-type-sticky" class="mr-4">Sticky</vs-radio>-->
          <!--                <vs-radio v-model="navbarTypeLocal" vs-value="floating" vs-name="navbar-type-floating">Floating</vs-radio>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; FOOTER TYPE &ndash;&gt;-->
          <!--            <div class="mt-4">-->
          <!--              <h5 class="mb-2">Footer Type</h5>-->
          <!--              <div>-->
          <!--                <vs-radio v-model="footerTypeLocal" vs-value="hidden" class="mr-4" vs-name="footer-type-hidden">Hidden</vs-radio>-->
          <!--                <vs-radio v-model="footerTypeLocal" vs-value="static" class="mr-4" vs-name="footer-type-static">Static</vs-radio>-->
          <!--                <vs-radio v-model="footerTypeLocal" vs-value="sticky" vs-name="footer-type-sticky">Sticky</vs-radio>-->
          <!--              </div>-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; RTL &ndash;&gt;-->
          <!--            <div class="mt-4 flex justify-between">-->
          <!--              <h5 class="mb-2">RTL</h5>-->
          <!--              <vs-switch v-model="rtl" />-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; SHOW SCROLL TO TOP &ndash;&gt;-->
          <!--            <div class="mt-4 flex justify-between">-->
          <!--              <h5 class="mb-2">Hide Scroll To Top</h5>-->
          <!--              <vs-switch v-model="hideScrollToTopLocal" />-->
          <!--            </div>-->

          <!--            <vs-divider />-->

          <!--            &lt;!&ndash; ROUTER ANIMATION &ndash;&gt;-->
          <!--            <div class="mt-4">-->
          <!--              <h5 class="mb-2">Router Animation {{ routerTransitionLocal }}</h5>-->
          <!--              <vs-select v-model="routerTransitionLocal">-->
          <!--                <vs-select-item-->
          <!--                  v-for="(item,index) in routerTransitionsList"-->
          <!--                  :key="index"-->
          <!--                  :value="item.value"-->
          <!--                  :text="item.text" />-->
          <!--              </vs-select>-->
          <!--            </div>-->

          <!--          </div>-->
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { Carousel, Slide } from "vue-carousel-variable-width";
export default {
  props: {
    footerType       : { type: String,  required: true },
    hideScrollToTop  : { type: Boolean, required: true },
    navbarType       : { type: String,  required: true },
    navbarColor      : { type: String,  required: true, default: '#fff' },
    routerTransition : { type: String,  required: true }
  },
  data () {
    return {
      active             : false,
      psrc:'',
      vsrc:'',
      customPrimaryColor : '#3DC9B3',
      customNavbarColor  : '#3DC9B3',
      routerTransitionsList: [
        { text: 'Zoom Fade',   value: 'zoom-fade'   },
        { text: 'Slide Fade',  value: 'slide-fade'  },
        { text: 'Fade Bottom', value: 'fade-bottom' },
        { text: 'Fade',        value: 'fade'        },
        { text: 'Zoom Out',    value: 'zoom-out'    },
        { text: 'None',        value: 'none'        }
      ],
      presentationsData:[
        { image: require("@/assets/images/slider/slide_p1.png"),
          url: 'https://www.scribd.com/embeds/591457967/content?start_page=1&view_mode=slideshow&access_key=key-8v6Moi7J2s77EMh12Mn7',
          title:'Coaching and Mentoring as levers of conscious leadership',
          description:'Growing your self-awareness and unique leadership style. Coaching and Mentoring are two arts of leadership that are built on core talents of listening, empathy and speaking with impact.\n' +
            '\n' +
            'Identifying different situations and types in the team and learning how to decode them to maximize the impact of your communication.\n' +
            '\n' +
            'Exploring coaching and mentoring techniques that fit your personal style and drive better relationships and results.'
        },
        { image: require("@/assets/images/slider/slide_p2.png"),
          url: 'https://www.scribd.com/embeds/591457969/content?start_page=1&view_mode=slideshow&access_key=key-eT27oXMOXGKy8Wd1QSHq',
          title:'Your Role as a Mentor and a Coach',
          description:'In a forest, there is no master tree that plans and dictates change when rain fails to fall or when the spring comes early. The whole ecosystem reacts creatively, in the moment.” It’s more than behaviour, It is a systemic approach of dynamic collaboration.'
        },
        { image: require("@/assets/images/slider/slide_p3.png"),
          url: 'https://www.scribd.com/embeds/594558973/content?start_page=1&view_mode=slideshow&access_key=key-xiOWD6tKxvu6QB8md1bQ',
          title:'Developing a Culture of Sustainable Performance',
          description:'Sustainable performance is driven by constent and constant action.  It is a continual, holistic process, as opposed to those based on a traditional, one-off annual appraisal. It enables our organization to create a trusted environment in which everyone feels empowered to take control of their own development.'
        },
        { image: require("@/assets/images/slider/slide_p4.png"),
          url: 'https://www.scribd.com/embeds/594560773/content?start_page=1&view_mode=slideshow&access_key=key-LMj7ahbWT5HzMnLrx68T',
          title:'Setting Up Org',
          description:'Question everything,” Albert Einstein famously said. Personal creativity and organizational innovation rely on a willingness to seek out novel information. Asking the right questions can unlock opportunities you didn\'t even realize existed and take your career to new heights. Configuring the surveys, nudges and relationship feedbacks as per the organizational ethos is essntial to make the relationship strong and the program effective.'
        },
        { image: require("@/assets/images/slider/slide_p5.png"),
          url: 'https://www.scribd.com/embeds/594576409/content?start_page=1&view_mode=slideshow&access_key=key-g1vf8l0tOa78Vaw2fUDR',
          title:'Player Goal Setting',
          description:'Goal setting is a purposeful and explicit process that starts with identifying a new objective, skill, or project you want to achieve. The first steps to goal setting is to plan for a BIG, SMART and WORTHY achievement that you can envision.\n' +
            '\n'
        },
        { image: require("@/assets/images/slider/slide_p6.png"),
          url: 'https://www.scribd.com/embeds/594582732/content?start_page=1&view_mode=slideshow&access_key=key-ELulDUrudl6kE6SueFUq',
          title:'Mentor Training on Product and Methodology to Set First Goal with Player',
          description:'A handbook to use the tool to set a proper goal, and manage the progression towards its achievement. How to monitor the development progress and resolve issues that may get in the way of the player reaching their goals.'
        },
        { image: require("@/assets/images/slider/slide_p7.png"),
          url: 'https://www.scribd.com/embeds/594584727/content?start_page=1&view_mode=slideshow&access_key=key-75eEz3UslXIC33wbyOXz',
          title:'Achieving BIG goals with Small Habits',
          description:'SET: How can we set good goals that align with our vision and mission?\n' +
            '\n' +
            ' \n' +
            '\n' +
            'STICK: Build support network.\n' +
            '\n' +
            ' \n' +
            '\n' +
            'SUSTAIN: Create meaningful reminders to nudge you into small habits.\n' +
            '\n' +
            '\n' +
            'SCORE: Celebrate small wins all along the way, Aim high with a “What if” and “Why not” mindset. Set your eyes up and hold your head high for you ‘Do’ or ‘Do not’, there is no Try.'
        },
        { image: require("@/assets/images/slider/slide_p8.png"),
          url: 'https://www.scribd.com/embeds/594589530/content?start_page=1&view_mode=slideshow&access_key=key-Yo2FuO2QAZ2hEbJ68FgE',
          title:'Monitoring Goals and Timing Interventions in Dynamic Environments',
          description:'There is a catch to all of the goal setting paradigms we discussed. It is based on two assumptions: The person has the ‘potential’ (ability) to achieve the set goal He will have the resources (environment) to achieve it This handbook describes how to manage the process and predict deviations on goals.'
        }
      ],
      videosData:[
        { image:require("@/assets/images/slider/slide_v1.png"),   url: 'https://www.youtube.com/embed/75d_29QWELk'   },
        { image:require("@/assets/images/slider/slide_v2.png"),  url: 'https://www.youtube.com/embed/aHDvEfiSipo'  }
      ],
      booksData:[
        { image: require("@/assets/images/slider/powerOfHabit.png"),   url: 'https://www.google.com/search?q=the+power+of+habit+book'   },
        { image: require("@/assets/images/slider/miracle.png"),  url: 'https://www.google.com/search?q=the+miracle+morning'  },
        { image: require("@/assets/images/slider/mindSet.png"),  url: 'https://www.google.com/search?q=mindset%3A+the+new+psychology+of+success'  },
        { image: require("@/assets/images/slider/5_second_rule.png"),   url: 'https://www.google.com/search?q=5+second+rule+mel+robbins+book'   },
        { image: require("@/assets/images/slider/deep_work.png"),  url: 'https://www.google.com/search?q=deep+work'  },
        { image: require("@/assets/images/slider/the_execuition.png"),  url: 'https://www.google.com/search?q=Execution%3A+The+Discipline+of+Getting+Things+Done'  },
        { image: require("@/assets/images/slider/the_infinte_game.png"),  url: 'https://google.com/search?q=the+infinite+game'  },
        { image: require("@/assets/images/slider/the_one_thing.png"),  url: 'https://www.google.com/search?q=the+one+thing'  },
        { image: require("@/assets/images/slider/thinking_fast_and_slow.png"),  url: 'https://www.google.com/search?q=the+international+bestseller+thinking+fast+and+slow'  },
        { image: require("@/assets/images/slider/a_thousand_brains.png"),  url: 'https://www.google.com/search?q=+A+THOUSAND+BRAINS'  },
        { image: require("@/assets/images/slider/think_again.png"),  url: 'https://www.google.com/search?q=Think+AGAIN+Adam+Grant'  },
        { image: require("@/assets/images/slider/power_of_subconscious.png"),  url: 'https://www.google.com/search?q=the+power+of+your+subconscious+mind'  },
        { image: require("@/assets/images/slider/the_compoud_effect.png"),  url: 'https://www.google.com/search?q=the+compound+effect'  },
        { image: require("@/assets/images/slider/the_ellimal_egos.png"),  url: 'https://www.google.com/search?q=Allemaal+EGOS'  },
        { image: require("@/assets/images/slider/unlocking_leadership.png"),  url: 'https://www.google.com/search?q=Unlocking+leadership'  },

      ],
      flag:false,
      flag1:false,
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60
      },
      themeColors: ['#9DCD5B', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
    }
  },
  watch: {
    layoutType (val) {

      // Reset unsupported options
      if (val === 'horizontal') {
        if (this.themeMode === 'semi-dark') this.themeMode = 'light'
        if (this.navbarType === 'hidden')   this.navbarTypeLocal = 'floating'
        this.$emit('updateNavbarColor', '#fff')
      }
    }
  },
  computed: {
    footerTypeLocal: {
      get ()    { return this.footerType },
      set (val) { this.$emit('updateFooter', val) }
    },
    hideScrollToTopLocal: {
      get ()    { return this.hideScrollToTop },
      set (val) { this.$emit('toggleHideScrollToTop', val) }
    },
    navbarColorInitial () {
      return this.$store.state.theme === 'dark' ? '#10163a' : '#fff'
    },
    navbarColorOptionClasses () {
      return (color) => {
        const classes = {}
        if (color === this.navbarColorLocal)   classes['shadow-outline'] = true
        if (this.navbarTypeLocal === 'static') classes['cursor-not-allowed'] = true
        return classes
      }
    },
    navbarColorLocal: {
      get () { return this.navbarColor },
      set (val) {
        if (this.navbarType === 'static') return
        this.$emit('updateNavbarColor', val)
      }
    },
    navbarTypeLocal: {
      get ()    { return this.navbarType },
      set (val) { this.$emit('updateNavbar', val) }
    },
    layoutType: {
      get ()    { return this.$store.state.mainLayoutType },
      set (val) { this.$store.commit('UPDATE_MAIN_LAYOUT_TYPE', val) }
    },
    primaryColor: {
      get ()    { return this.$store.state.themePrimaryColor },
      set (val) { this.$store.commit('UPDATE_PRIMARY_COLOR', val) }
    },
    reduced_sidebar: {
      get ()    { return this.$store.state.reduceButton },
      set (val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    routerTransitionLocal: {
      get ()    { return this.routerTransition },
      set (val) { this.$emit('updateRouterTransition', val) }
    },
    rtl: {
      get ()    { return this.$vs.rtl },
      set (val) { this.$vs.rtl = val  }
    },
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
    scrollbarTag () { return this.$store.state.is_touch_device ? 'div' : 'VuePerfectScrollbar' },
    windowWidth () {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    updatePrimaryColor (color) {
      this.primaryColor = color
      this.$vs.theme({ primary: color })
    },
    presentationShow(item){
      this.flag = true;
      this.psrc=item.url;

    },
    videoPlay(item){
      this.flag1 = true;
      this.vsrc=item.url;
    }
  },
  components: {
    VuePerfectScrollbar,
    Carousel,
    Slide
  }
}

</script>


<style lang="scss">
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 100vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
  }
}

.customizer-btn {
  position: fixed;
  top: 50%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;

  .vs-icon {
    animation: spin 1.5s linear infinite;
  }
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.VueCarousel-slide {
  width: 250px;
  flex-basis: initial;
  padding:20px;
}
.VueCarousel-slide img {
  width: 100%;
  display: block;
}
.editor-iframe {
  width: 100%;
  height: calc(82vh);
}
</style>

